import Link from 'next/link';

interface DropdownItemProps {
  href: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

export function DropdownItem({
  href,
  children,
  icon,
}: Readonly<DropdownItemProps>) {
  return (
    <Link
      href={href}
      className="
        flex items-center gap-3  px-5 py-2.5 text-base font-bold  text-ordianry 
        hover:bg-[#EEF4FF]  transition-colors
      "
    >
      {icon && <span className="text-gray-400">{icon}</span>}
      <span>{children}</span>
    </Link>
  );
}